import script from "./Default.vue?vue&type=script&setup=true&lang=ts"
export * from "./Default.vue?vue&type=script&setup=true&lang=ts"

import "./Default.vue?vue&type=style&index=0&id=77098bd2&lang=scss"

const __exports__ = script;

export default __exports__